import { Grid } from "antd";

const { useBreakpoint } = Grid;

export const useResponsive = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  const isTablet = Boolean(screens.sm && !screens.lg);
  const isDesktop = Boolean(screens.lg);
  const isWideDesktop = Boolean(screens.xl);
  const isCompactHeader = !screens.lg;
  const isCardListView = !screens.md;

  return {
    screens,
    isMobile,
    isTablet,
    isDesktop,
    isWideDesktop,
    isCompactHeader,
    isCardListView,
  };
};
